import PropTypes from "prop-types";

export default function CurrentCompTable({ compositions }) {
  const hasLinkage = compositions.some((row) => row?.linkage);
  return (
    <div className="index-table-cur-comp-wrapper mb-15" dir={"rtl"}>
      <table
        className="index-table-cur-comp"
        cellSpacing="0"
        rules="all"
        border="1"
      >
        <thead>
          <tr align="justify">
            <th scope="col" align="center" className="index-table-th-blue">
              Weight
            </th>
            {hasLinkage && (
              <th scope="col" align="center" className="index-table-th-blue">
                Linkage
              </th>
            )}
            <th scope="col" align="center" className="index-table-th-blue">
              Ticker-Region
            </th>
            <th scope="col" align="center" className="index-table-th-blue">
              Name
            </th>
            <th scope="col" align="center" className="index-table-th-blue">
              #
            </th>
          </tr>
        </thead>
        <tbody>
          {compositions.map((row, i) => (
            <tr key={row.isin || i}>
              <td align="center" >
                {row.weight ? (
                  <div>
                    %{" "}
                    <span >
                      {(row.weight * 100).toFixed(4)}
                    </span>
                  </div>
                ) : (
                  ""
                )}
              </td>
              {hasLinkage && <td align="center">{row?.linkage || ""}</td>}
              <td align="center">
                {row?.ticker_region || row?.exchange_asset_id || ""}
              </td>
              <td align="left">{row?.asset_name || ""}</td>
              <td align="center" style={{ width: "30px" }}>
                {i + 1}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
CurrentCompTable.propTypes = {
  compositions: PropTypes.arrayOf(
    PropTypes.shape({
      isin: PropTypes.string,
      weight: PropTypes.number,
      linkage: PropTypes.string,
      ticker_region: PropTypes.string,
      exchange_asset_id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      asset_name: PropTypes.string,
    })
  ).isRequired,
};
